module.exports = __webpack_public_path__ + "img/download-2-INTphone.61ba01d6.png";